import { BriefcaseIcon } from '@heroicons/react/24/solid';
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline';
import type { JSX } from 'react';

/** Types */
interface GetJobTitleResponse {
  title: string;
  subtitle: string;
  icon: JSX.Element;
}
type JobTitleType = 'occupation' | 'job';
type JobTitleDataType = Record<JobTitleType, Omit<GetJobTitleResponse, 'title'>>;
type GetFormattedJobTitle = (jobTitleItem: ApiSchema<'JobContentModel'>) => GetJobTitleResponse;

/** Data */
const iconClass = 'mt-px size-5 shrink-0';
const JobTitleData: JobTitleDataType = {
  occupation: {
    subtitle: '',
    icon: <ArrowRightCircleIcon className={`${iconClass} text-ink-light`} />,
  },
  job: {
    subtitle: 'job.add.label.preselected.type.job',
    icon: <BriefcaseIcon className={`${iconClass} text-secondary`} />,
  },
};

/**
 * @description Get formatted job title
 * @param jobTitleItem - Job title item
 */
export const getFormattedJobTitle: GetFormattedJobTitle = (jobTitleItem) => {
  // Destructure job title item
  const {
    name,
    type,
  } = jobTitleItem;

  // Get the proper type
  const jobType: JobTitleType = type === 'job' ? 'job' : 'occupation';

  // Get job title data
  const jobTitleData = JobTitleData[jobType];

  // Return formatted job title
  return {
    title: name,
    subtitle: jobTitleData.subtitle,
    icon: jobTitleData.icon,
  };
};
